import z from 'zod';
import { taskDescriptorSchema, folderDescriptorSchema, stackDescriptorSchema } from './schema.v2.descriptor.js';
import { settingsSchema } from './schema.v2.settings.js';

/**
 * Specification of an opgavekomplekset task set in the v2 format
 */

const opgavekompleksetV2DataSchema = z.object({
  version: z.literal("2"),
  descriptors: z.array(z.discriminatedUnion("type", [taskDescriptorSchema, folderDescriptorSchema, stackDescriptorSchema])),
  settings: settingsSchema
});

export { opgavekompleksetV2DataSchema };
//# sourceMappingURL=_component-data.v2.js.map
